module.exports = __webpack_public_path__ + "static/media/react.81515a23.png";